import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Logo } from "./Logo";
import {
  LayoutDashboard, Users, BookOpen, Flag, Award, Megaphone, ScrollText, Settings, LogOut, ArrowLeft,
} from "lucide-react";

const nav = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/users", label: "User Management", icon: Users },
  { to: "/admin/paths", label: "Learning Paths", icon: BookOpen },
  { to: "/admin/ctf", label: "CTF Challenges", icon: Flag },
  { to: "/admin/certificates", label: "Certificates", icon: Award },
  { to: "/admin/announcements", label: "Announcements", icon: Megaphone },
  { to: "/admin/audit", label: "Audit Logs", icon: ScrollText },
  { to: "/admin/config", label: "Configuration", icon: Settings },
];

export function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0B1120] flex">
      <aside className="w-60 shrink-0 border-r border-white/5 bg-[#0B1120] hidden md:flex flex-col fixed h-screen">
        <div className="h-16 flex items-center px-5 border-b border-white/5">
          <Logo className="h-8" />
        </div>
        <div className="px-3 py-2">
          <span className="overline px-2">Super Admin</span>
        </div>
        <nav className="flex-1 px-3 space-y-1 overflow-y-auto">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`admin-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isActive ? "text-white bg-[#F26522]/15 border-l-2 border-[#F26522]" : "text-slate-400 hover:text-white hover:bg-white/5"
                }`
              }
            >
              <n.icon size={18} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/5 space-y-1">
          <Link to="/app/dashboard" className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-slate-400 hover:text-white hover:bg-white/5">
            <ArrowLeft size={18} /> Learner View
          </Link>
          <button onClick={() => { logout(); navigate("/"); }} className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-red-400 hover:bg-red-500/10 w-full" data-testid="admin-logout-btn">
            <LogOut size={18} /> Logout
          </button>
        </div>
      </aside>

      <div className="flex-1 md:ml-60">
        <header className="md:hidden glass border-b border-white/5 h-14 flex items-center justify-between px-4 sticky top-0 z-30">
          <Logo className="h-7" />
          <Link to="/app/dashboard" className="btn-ghost text-sm">Learner</Link>
        </header>
        <div className="hidden md:flex items-center justify-end gap-3 h-14 px-6 border-b border-white/5">
          <span className="text-sm text-slate-400">Signed in as <span className="text-white font-medium">{user?.full_name}</span></span>
        </div>
        <main className="p-4 sm:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
